import { useState, useCallback, useEffect } from 'react'

export interface StickyConfig {
  topBuffer?: number
  bottomBuffer?: number
  showOnLoad?: boolean
}

const useSticky = ({
  topBuffer = 1,
  bottomBuffer = 580,
  showOnLoad,
}: StickyConfig = {}) => {
  const [stickyIsActive, setStickyIsActive] = useState(showOnLoad)

  const determinePosition = useCallback(() => {
    if (typeof window !== 'undefined') {
      const scrollDistance = window.pageYOffset
      const atTopOfPage = scrollDistance < topBuffer

      const footerInView =
        scrollDistance + window.innerHeight >
        document.body.offsetHeight - bottomBuffer

      setStickyIsActive(!(atTopOfPage || footerInView))
    }
  }, [bottomBuffer, topBuffer])

  useEffect(() => {
    determinePosition()
    window.addEventListener('scroll', determinePosition)
    window.addEventListener('resize', determinePosition)

    return () => {
      window.removeEventListener('scroll', determinePosition)
      window.removeEventListener('resize', determinePosition)
    }
  }, [determinePosition])

  return stickyIsActive
}

export default useSticky
